import { Box, IconButton, styled } from "@mui/material";

export const StyledFormBasics = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.custom.purple[50],
  padding: `${theme.spacing(1)} ${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(1.5)}`,
  borderRadius: "8px",
  boxShadow: "none",
  border: "none",
}));

export const StyledProfileContent = styled(Box)({
  padding: 0,
});

export const StyledFieldBox = styled(Box)({
  display: "flex",
  flex: 1,
});

export const StyledIconButton = styled(IconButton)({
  size: "small",
});
